<!-- eslint-disable vue/no-v-html -->
<script>
export default {
    name: 'Daily',

    props: {
        viewSelectorHeight: {
            type: Number,
            required: true
        },
        zenHeaderHeight: {
            type: Number,
            required: true
        },
        dataSet: {
            type: Object,
            required: true
        },
        calendar: {
            type: Object,
            required: true
        }
    },

    computed: {
        occasions() {
            return this.calendar.getOccasionsForDay(this.dateFormatDayISO(this.dataSet.navDay))
        }
    },
}
</script>

<template>
    <div>
        <div
            class="container-fluid"
            :style="{
                position: 'sticky',
                top: zenHeaderHeight+viewSelectorHeight+'px',
                backgroundColor: 'white',
                zIndex: 41
            }"
        >
            <div class="container">
                <daily-nav
                    :data-set="dataSet"
                    v-on="$listeners"
                />
            </div>
        </div>
        <div class="container-fluid">
            <div class="container">
                <div class="row pt-4">
                    <div
                        class="col-12 col-sm-3 text-selection-none d-sm-block d-flex align-items-end"
                        :class="occasions.length ? 'justify-content-between' : 'justify-content-start'"
                    >
                        <div>
                            <div class="text-uppercase dayname">
                                {{ dateFormatDayname(dataSet.navDay) }}
                            </div>
                            <div class="daynumber pb-3 pb-sm-0">
                                {{ dateFormatDaynumber(dataSet.navDay) }}
                            </div>
                        </div>
                        <!-- MOBILE BELOW -->
                        <div
                            v-if="occasions.length"
                            class="d-block d-sm-none pb-3 occasions-count"
                            v-html="__('Events in total: <strong>:count</strong>', { count: occasions.length })"
                        />
                        <!-- - -->

                        <div
                            v-else
                            class="d-block d-sm-none align-self-end pb-3 pl-3 no-occasions"
                        >
                            {{ __('No programs available') }}
                        </div>
                    </div>
                    <div class="col-12 col-sm-9">
                        <div class="row-on-desktop h-100">
                            <div
                                v-if="!occasions.length"
                                class="d-none d-sm-block my-auto no-occasions"
                            >
                                {{ __('No programs available') }}
                            </div>
                            <div
                                v-for="(occasion, idx) in occasions"
                                :key="idx"
                                class="col-9 col-md-4 mr-3 mr-sm-0 pb-3"
                            >
                                <div class="h-100">
                                    <event-item :occasion="occasion" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <daily-nav
                    bottom-nav
                    :data-set="dataSet"
                    v-on="$listeners"
                /> -->
            </div>
        </div>
    </div>
</template>
